import axios from 'axios';

export default {
  FETCH_PLAYLISTS ({commit, dispatch}, payload){
    return new Promise((resolve, reject) => {
      commit('TOGGLE_LOADING', true);
      // axios.post('login/authenticate', payload)
      axios.get('playlists/getAllCorporationPlaylistsWithVideos')
        .then((response) => {
          const { data: { data : { payload } } } = response;
          localStorage.setItem('playlists', JSON.stringify(payload));
          commit('SET_PLAYLIST', payload);
          commit('TOGGLE_LOADING', false);
          resolve(payload);

        })
        .catch((error) => {
          console.log('action fetch error : ', error);
          reject(error);
          commit('TOGGLE_LOADING', false);
        });
    })
  },
  FILTER_PLAYLISTS ({commit, dispatch}, filterText){
    return new Promise((resolve, reject) => {
      commit('TOGGLE_LOADING', true);
      axios.get(`/playlists/searchAlikeTitleVideos/${filterText}`)
        .then((response) => {
          const { data: { data : { payload } } } = response;
          commit('SET_FILTER_RESULTS', payload);
          commit('TOGGLE_LOADING', false);
          resolve(payload);

        })
        .catch((error) => {
          console.log('action fetch error : ', error);
          reject(error);
          commit('TOGGLE_LOADING', false);
        });
    })
  },
  GETSELECTEDPLAYLIST ({ commit }, playlistId) {
    commit('TOGGLE_LOADING', true);
    return axios.get(`playlists/getAllCorporationPlaylistsWithVideos`).then((response) => {
      commit('TOGGLE_LOADING', false);
      const { data: { data : { payload }} } = response;
      let selectedPlaylist = payload.filter(x => {
        return x.playlistId.toString() === playlistId.toString()
      });
      console.log('found playlist', selectedPlaylist[0])
      commit('SET_SELECTED_PLAYLIST', selectedPlaylist[0])
    }, (err) => {
      commit('TOGGLE_LOADING', false);
      console.log('err ', err)
    })
  },
  ADD_PLAYLIST({commit, dispatch}, payload){
    payload.csvCorporationId = payload.csvCorporationId.toString()
    console.log('add payload', payload)
    return new Promise((resolve, reject) => {
      commit('TOGGLE_LOADING', true);
      console.log("add playlist payload : ", payload);
      axios.post('playlists/insertCorporationPlaylistWithVideos', payload)
        .then((response) => {
          console.log('ADD_PLAYLIST action fetch response : ', response);
          const { data: { data } } = response;
          commit('TOGGLE_LOADING', false);
          resolve(data);
        })
        .catch((error) => {
          console.log('ADD_PLAYLIST action fetch error : ', error);
          reject(error);
          commit('TOGGLE_LOADING', false);
        });
    })
  },
  // UPDATE_VIDEO_META_DATA({commit, dispatch}, csvVideoCodes){
  //   console.log('new meta data paylaod', csvVideoCodes )
  //   return new Promise((resolve, reject) => {
  //     commit('TOGGLE_LOADING', true);
  //     axios.post('/corporations/updateToneDBWithJWData', {csvVideoCodes: csvVideoCodes} )
  //       .then((response) => {
  //         const { data: { data } } = response;
  //         commit('TOGGLE_LOADING', false);
  //         resolve(data);
  //       })
  //       .catch((error) => {
  //         console.log('UPDATE_PLAYLIST action fetch error : ', error);
  //         reject(error);
  //         commit('TOGGLE_LOADING', false);
  //       });
  //   })
  // },
  UPDATE_PLAYLIST({commit, dispatch}, payload){
    console.log('updaet payload', payload)
    console.log('playload id', payload.playlistId)
    let updatePayload = {
      'playlistId': payload.playlistId,
      'csvCorporationId': payload.csvCorporationId.toString(),
      'playlistTitle': payload.playlistTitle,
      'playlistDescription': payload.playlistDescription,
      'csvVideoCodes': payload.csvVideoCodes,
      'active': payload.active
    }
    console.log('new paylaod', updatePayload)
    return new Promise((resolve, reject) => {
      commit('TOGGLE_LOADING', true);
      axios.post('/playlists/updateCorporationPlaylistWithVideos', updatePayload)
        .then((response) => {
          const { data: { data } } = response;
          commit('TOGGLE_LOADING', false);
          resolve(data);
        })
        .catch((error) => {
          console.log('UPDATE_PLAYLIST action fetch error : ', error);
          reject(error);
          commit('TOGGLE_LOADING', false);
        });
    })
  },
  UPDATE_PLAYLIST_CORPORATION_NEW({commit, dispatch}, payload){
    console.log('updaet payload', payload)
    console.log('playload id', payload.playlistId)
    let updatePayload = {
      'playlistId': payload.playlistId,
      'csvCorporationId': payload.csvCorporationId.toString(),
      'playlistTitle': payload.playlistTitle,
      'playlistDescription': payload.playlistDescription,
      'csvVideoCodes': payload.csvVideoCodes,
      'active': payload.active
    }
    console.log('new paylaod', updatePayload)
    return new Promise((resolve, reject) => {
      commit('TOGGLE_LOADING', true);
      axios.post('/playlists/updateCorporationPlaylistWithVideos', updatePayload)
        .then((response) => {
          const { data: { data } } = response;
          commit('TOGGLE_LOADING', false);
          resolve(data);
        })
        .catch((error) => {
          console.log('UPDATE_PLAYLIST action fetch error : ', error);
          reject(error);
          commit('TOGGLE_LOADING', false);
        });
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/playlists/actions.js